import React from "react";
import { PartModel } from "../../Models/PartModel";
import "./Part.css";
import { Dropdown, DropdownButton } from "react-bootstrap";


interface Props {
  partModel: PartModel;
}

const PartSection = (props: Props) => {
  return (
    <div className="container mt-5">
        <div className="card shadow-sm p-4">
            <div className="row align-items-center">
                <div className="col-md-3">
                    <img
                    src={ props.partModel.part_image_url } className="part-image p-0 img-fluid rounded"
                    alt="Part"
                    />
                </div>
                <div className="col-md-7">
                    <h3>{ props.partModel.make }</h3>
                    <p className="text-muted">{ props.partModel.model }</p>
                </div>
                <div className="col-md-2 align-items-right">
                    <div className="row align-items-right">
                            <DropdownButton id="part-options" title="Options">
                                <Dropdown.Item href="#/action-1">Buy same part</Dropdown.Item>
                                <Dropdown.Item href="#/action-2">Search for compatible replacement</Dropdown.Item>
                            </DropdownButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default PartSection;
